import { useDevice } from '../../../../store/devices/useDevices.ts';

import { HomeyColors } from '../../../../theme/HomeyColors';

import { getOverrideURL } from '../../../../components/device/DeviceIcon';

import { ColumnItemDefault } from './ColumnItemDefault';

export function ColumnItemDevice(props) {
  const { device } = useDevice({ deviceId: props.deviceId });

  const iconOverride = device?.iconOverride;
  const backgroundColor = device?.color ?? HomeyColors.getColorForUri('homey:manager:devices');
  const url = iconOverride != null ? getOverrideURL({ iconOverride: iconOverride }) : null;

  return (
    <ColumnItemDefault url={url} iconObj={device?.iconObj} backgroundColor={backgroundColor} />
  );
}
